// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__30RnU","icon":"style_icon__3Hgn2","title":"style_title__1gHnT"};